import { render, staticRenderFns } from "./BookingEditPageFacilityPanel2.vue?vue&type=template&id=4ec2cf1e&scoped=true&"
import script from "./BookingEditPageFacilityPanel2.vue?vue&type=script&lang=js&"
export * from "./BookingEditPageFacilityPanel2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec2cf1e",
  null
  
)

export default component.exports